import React, { Component } from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import moment from 'moment'
import isEqual from 'lodash/isEqual'
import { snakeToPascalCase } from 'utils/StringFormat'

import Styles from './index.scss'

class InvoiceItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checkboxData: {},
      creatorsInvoice: [],
    }

    this.onCheckGenerate = this.onCheckGenerate.bind(this)
    this.onCheckAll = this.onCheckAll.bind(this)
    this.batchGenereatePaymentSlip = this.batchGenereatePaymentSlip.bind(this)
  }

  componentDidMount() {
    this.generateSelectedCreatorsInvoice()
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.invoice.creators, prevProps.invoice.creators)) {
      this.generateSelectedCreatorsInvoice()
    }
  }

  onCheckGenerate(idProfile, profileId) {
    return event => {
      const checkboxData = { ...this.state.checkboxData }
      checkboxData[idProfile] = {
        value: event.target.checked,
        profileId,
      }
      this.setState({ checkboxData })
    }
  }

  onCheckAll(event) {
    const checkboxData = { ...this.state.checkboxData }
    this.props.invoice.creators.forEach(creator => {
      if (!creator.remittanceUrl) {
        checkboxData[creator.profile.id] = {
          value: event.target.checked,
          profileId: creator.profileId,
        }
      }
    })
    this.setState({ checkboxData })
  }

  batchGenereatePaymentSlip() {
    const checkboxData = { ...this.state.checkboxData }
    Object.keys(checkboxData).forEach(key => {
      if (checkboxData[key].value) {
        const funcGenerate = this.props.generatePaymentSlip(
          key,
          this.props.invoice.id,
          this.props.invoice.invoiceType,
          checkboxData[key].profileId,
          this.props.totalInvoice,
          this.props.index
        )
        funcGenerate()
      }
    })
  }

  generateSelectedCreatorsInvoice() {
    const invoices = this.props.selectedCreators.map(creator => {
      const filteredData = this.props.invoice.creators.filter(
        sc => sc.profileId === creator.profileId
      )
      return filteredData[0]
    })
    this.setState({
      creatorsInvoice: invoices,
    })
  }

  render() {
    let title = 'Invoice'
    let totalChecked = 0
    Object.keys(this.state.checkboxData).forEach(key => {
      if (this.state.checkboxData[key].value) {
        totalChecked += 1
      }
    })
    const numbering = this.props.index + 1
    if (numbering < 10) {
      title = `Invoice 000${numbering}`
    } else if (numbering >= 10 && numbering < 100) {
      title = `Invoice 00${numbering}`
    } else {
      title = `Invoice 0${numbering}`
    }
    return (
      <section className={`section-tab ${Styles['section-invoice']}`}>
        <div className={`${Styles['invoice-container']}`}>
          <div className={`${Styles['invoice-list-title']}`}>
            <h4 className={`${Styles['title-label']}`}>{title}</h4>
          </div>
          <div className={`${Styles['invoice-info-container']}`}>
            <div className={`${Styles['info-content']}`}>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Profile</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {this.props.invoice.profile.name}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Is Expired</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {this.props.invoice.is_expired ? 'True' : 'False'}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Url</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  <a
                    href={this.props.invoice.url}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {`${this.props.invoice.url.substring(0, 30)}...`}
                  </a>
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Vat</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  <NumberFormat
                    thousandSeparator
                    displayType="text"
                    value={this.props.invoice.vat}
                  />
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Total</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  <NumberFormat
                    thousandSeparator
                    displayType="text"
                    value={this.props.invoice.total}
                  />
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Status</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {this.props.invoice.statusLabel}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Payment Method</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {snakeToPascalCase(this.props.invoice.paymentMethod || '')}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Created At</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {moment(this.props.invoice.createdAt).format('DD MMMM YYYY')}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Updated At</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {moment(this.props.invoice.updatedAt).format('DD MMMM YYYY')}
                </span>
              </div>
            </div>
            <div className={`${Styles['info-content']}`}>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Invoice Number</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {this.props.invoice.invoiceNumber}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Sub Total</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  <NumberFormat
                    thousandSeparator
                    displayType="text"
                    value={this.props.invoice.subTotal}
                  />
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Processing Fee</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {this.props.invoice.processingFee}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Due Date</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {moment(this.props.invoice.dueDate).format('DD MMMM YYYY')}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Deadline Date</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {moment(this.props.invoice.deadlineDate).format('DD MMMM YYYY')}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Expired Date</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {moment(this.props.invoice.expiredDate).format('DD MMMM YYYY')}
                </span>
              </div>
              <div className={`${Styles['item-container']}`}>
                <span className={`${Styles.item} ${Styles.label}`}>Invoice Type</span>
                <span className={`${Styles.item} ${Styles.value}`}>
                  {this.props.invoice.invoiceType}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={`${Styles['payment-title']}`}>
          <div className={`${Styles['title-label']}`}>Creator to Pay</div>
          <div>
            <span className={`${Styles['payment-count']}`}> {totalChecked} Selected</span>
            <button
              className={`${Styles['generate-invoice-btn']} ${
                totalChecked > 0 ? Styles.active : ''
              }`}
              disabled={totalChecked === 0}
              onClick={this.batchGenereatePaymentSlip}
            >
              Generated Selected Payment Slip
            </button>
          </div>
        </div>
        <div className={`${Styles['payment-list-container']}`}>
          <table className={`${Styles['table-list']}`}>
            <thead>
              <tr>
                <th>Profile ID</th>
                <th>Amount</th>
                <th>Bank Details</th>
                <th>Tax Invoice</th>
                <th>
                  <input type="checkbox" onChange={this.onCheckAll} />
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {this.state.creatorsInvoice.map(creator => (
                <tr key={creator.id}>
                  <td>{creator.profile.profileId}</td>
                  <td>
                    <NumberFormat
                      thousandSeparator
                      displayType="text"
                      value={creator.amount}
                    />
                  </td>
                  <td>{creator.bankName}</td>
                  <td>
                    {creator.taxInvoiceUrl ? (
                      <a href={this.props.invoice.taxInvoiceUrl}>View</a>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    {creator.remittanceUrl ? (
                      <div />
                    ) : (
                      <input
                        type="checkbox"
                        checked={
                          this.state.checkboxData[creator.profile.id]
                            ? this.state.checkboxData[creator.profile.id].value
                            : false
                        }
                        onChange={this.onCheckGenerate(
                          creator.profile.id,
                          creator.profileId
                        )}
                      />
                    )}
                  </td>
                  <td className={`${Styles['btn-rows']}`}>
                    {creator.remittanceUrl ? (
                      <a
                        href={creator.remittanceUrl}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        View Payment Slip
                      </a>
                    ) : (
                      <button
                        className={`${Styles['generate-btn']}`}
                        onClick={this.props.generatePaymentSlip(
                          creator.profile.id,
                          this.props.invoice.id,
                          this.props.invoice.invoiceType,
                          creator.profileId,
                          this.props.totalInvoice,
                          this.props.index
                        )}
                        disabled={this.props.upload.isUploading ? 'disabled' : ''}
                      >
                        {this.props.upload.isUploading
                          ? 'Generating.....'
                          : 'Generate Payment Slip'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    )
  }
}

InvoiceItem.propTypes = {
  invoice: PropTypes.shape({
    profile: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    is_expired: PropTypes.bool.isRequired,
    url: PropTypes.string,
    vat: PropTypes.number,
    total: PropTypes.number,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    statusLabel: PropTypes.string,
    invoiceNumber: PropTypes.string,
    subTotal: PropTypes.number,
    processingFee: PropTypes.number,
    dueDate: PropTypes.string,
    deadlineDate: PropTypes.string,
    expiredDate: PropTypes.string,
    invoiceType: PropTypes.string,
    creators: PropTypes.arrayOf(PropTypes.object).isRequired,
    id: PropTypes.string,
    taxInvoiceUrl: PropTypes.string,
    paymentMethod: PropTypes.string,
  }).isRequired,
  index: PropTypes.number.isRequired,
  generatePaymentSlip: PropTypes.func.isRequired,
  upload: PropTypes.shape({
    isUploading: PropTypes.bool,
  }).isRequired,
  totalInvoice: PropTypes.number.isRequired,
  selectedCreators: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default InvoiceItem
